import { FieldGroup } from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";

import { PersonApi } from "../../../../api";
import { FGSRSHCheckboxInput, SmallFormGenerator } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { PersonMembershipHistoryList } from "./membershipHistory/PersonMembershipHIstoryList";

export interface IPersonMembershipPageProps {
  personId: number;
}

export const PersonMembershipPage: React.FunctionComponent<IPersonMembershipPageProps> = ({ personId }) => {
  const { t } = useTl();
  const { state } = useParams<{ state: string }>();
  const api = useApiService(PersonApi);

  const { data, loading, saving, saveItem } = useCrudApi(
    {
      getApiFn: () => api.getMembership(personId),
      saveApiFn: (d) => api.saveMembership(d),
      deleteApiFn: (d) => {},
    },
    [personId]
  );

  return (
    <>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={state === "edit"}
        loading={loading}
        showDeleteButton={false}
        saving={saving}
      >
        <FieldGroup
          fieldsetProps={{
            title: t(ETLCodes.Detail),
            rightElement: (
              <div>
                {data?.memberNumber && data?.memberNumber > 0
                  ? `${t(ETLCodes.MemberNumber)}: ${data?.memberNumber}`
                  : ""}
              </div>
            ),
          }}
        >
          <FGSRSHCheckboxInput name="isCAMember" label={t(ETLCodes.IsCAMember)} />
          <FGSRSHCheckboxInput name="isCEMember" label={t(ETLCodes.IsCEMember)} />
          <FGSRSHCheckboxInput name="isCynologicCouncilMember" label={t(ETLCodes.IsCynologicCouncilMember)} />
          <FGSRSHCheckboxInput name="isFCIDelegateMember" label={t(ETLCodes.IsFCIDelegateMember)} />
          <FGSRSHCheckboxInput name="isVDA" label={t(ETLCodes.IsVDA)} />
          <FGSRSHCheckboxInput name="isSupervisor" label={t(ETLCodes.IsSupervisor)} />
          <FGSRSHCheckboxInput name="isVolunteer" label={t(ETLCodes.IsVolunteer)} />
        </FieldGroup>
      </SmallFormGenerator>
      <PersonMembershipHistoryList personId={personId}/>
    </>
  );
};
